import { render, staticRenderFns } from "./feeManage.vue?vue&type=template&id=4a8a738c"
import script from "./feeManage.vue?vue&type=script&lang=js"
export * from "./feeManage.vue?vue&type=script&lang=js"
import style0 from "./feeManage.vue?vue&type=style&index=0&id=4a8a738c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports